// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploaded-img-name {\n    display: inline-block;\n    margin-right: 20px;\n    max-width: 205px;\n    text-align: left;\n    font-size: 15px;\n}", ""]);
// Exports
module.exports = exports;
